<template>
  <v-layout column align-center v-scroll="searchMore">
    <v-col
      cols="9"
      md="9"
      lg="9"
      xl="9"
      sm="12"
      xs="2"
      xm="2"
      class="mt-8 ml-0"
    >
      <div id="main">
        <v-row :class="{ 'ml-n12': $vuetify.breakpoint.mdAndUp }">
          <span
            class="mb-7 text-right display-1 font-weight-bold grey--text text--darken-1"
          >
            {{ "Pools Virtuais" }}</span
          >
        </v-row>

        <v-row id="filtro" class="pl-2 ml-0 grey lighten-5">
          <v-col cols="4" class="mr-0 pl-4 pr-8">
            <v-row>
              <span
                class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
              >
                {{ $vuetify.lang.t("$vuetify.BUSCAR") }}:</span
              >
            </v-row>
            <v-row md="2">
              <v-text-field
                v-model.trim="searchText"
                dense
                label="Regular"
                placeholder="Buscar por nome do Pool ou contrato"
                single-line
                solo
                append-icon="mdi-magnify"
                @click:append="search()"
                @keypress.enter="search()"
              ></v-text-field>
            </v-row>
          </v-col>

          <v-col class="mt-5 ml-n5">
            <v-menu
              transition="slide-x-transition"
              bottom
              right
              v-show="!$vuetify.breakpoint.xs"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  class="ma-2"
                  dark
                  color="blue darken-2"
                  v-on="on"
                  :x-small="$vuetify.breakpoint.xs"
                  :small="!$vuetify.breakpoint.xs"
                  :loading="loadingExport"
                >
                  {{ $vuetify.lang.t("$vuetify.ACOES") }}
                  <v-icon right dark> mdi-chevron-down </v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item @click="createPool()">
                  <v-list-item-title>{{
                    "Novo Pool Virtual"
                  }}</v-list-item-title>
                </v-list-item>

                <!--<v-list-item @click="exportCSV()">
                  <v-list-item-title>{{
                    $vuetify.lang.t("$vuetify.EXPORTAR_CSV")
                  }}</v-list-item-title>
                </v-list-item>-->
              </v-list>
            </v-menu>
          </v-col>
        </v-row>

        <v-row class="pl-2 pr-2" style="margin-left: -2px">
          <v-expansion-panels class="ma-1">
            <v-expansion-panel
              v-for="(pool, i) in pools"
              :key="i"
              hide-actions
              :disabled="disabled"
            >
              <v-expansion-panel-header v-slot="{ open }" style="z-index: 1000">
                <v-row align="center" no-gutters>
                  <v-col v-show="!$vuetify.breakpoint.xs" sm="5" md="4">
                    <strong
                      class="subtitle-2 font-weight-bold"
                      v-html="pool.nome"
                    ></strong>
                  </v-col>
                  <v-spacer></v-spacer>

                  <v-chip
                    v-if="!open"
                    :color="pool.consumoGB < pool.tamanhoGB ? 'blue darken-2' : 'red'"
                    class="ml-0 mr-3"
                    label
                    small
                    outlined
                  >
                    {{
                      formatSize(pool.consumoGB) +
                      " / " +
                      formatSize(pool.tamanhoGB)
                    }}
                  </v-chip>
                </v-row>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="2" class="ml-3">
                    <v-row sm="1">
                      <v-chip
                        v-if="!open"
                        :color="pool.consumoGB < pool.tamanhoGB ? 'blue darken-2' : 'red'"
                        class="ml-0 mr-3"
                        label
                        small
                        outlined
                      >
                        {{
                          formatSize(pool.consumoGB) +
                          " / " +
                          formatSize(pool.tamanhoGB)
                        }}
                      </v-chip>
                    </v-row>
                  </v-col>

                  <v-col class="mt-2 ml-12">
                    <v-row
                      class="mt-0 ml-1"
                      :class="{ 'pl-10 pt-3 ml-n5': $vuetify.breakpoint.xs }"
                    >
                      <v-col
                        class="pt-0 pl-0 pr-0 mt-n6 col-4 ml-n3"
                        :class="{ 'col-6 ml-0': $vuetify.breakpoint.xs }"
                      >
                        <LabelValue
                          :label="$vuetify.lang.t('$vuetify.CONTRATO')"
                          :value="pool.contrato ? pool.contrato.nome : '--'"
                          justify="start"
                          style="width: 350px"
                          truncate
                        ></LabelValue>
                      </v-col>

                      <v-col
                        class="pt-0 pl-0 pr-0 mt-n6 col-4 ml-n3"
                        :class="{ 'col-6 ml-0': $vuetify.breakpoint.xs }"
                      >
                        <LabelValue
                          :label="'Estrangular banda'"
                          :value="pool.estrangularBanda ? 'Sim' : 'Não'"
                          justify="start"
                          style="width: 350px"
                          truncate
                        ></LabelValue>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-divider class="mt-0"></v-divider>

                <v-card-actions class="mb-n3">
                  <TooltipButton
                    :label="$vuetify.lang.t('$vuetify.EDITAR')"
                    :message="$vuetify.lang.t('$vuetify.EDITAR')"
                    :event="editPool"
                    :mobile="$vuetify.breakpoint.xs"
                    :isText="true"
                    :object="pool"
                  ></TooltipButton>

                  <TooltipButton
                    :label="'Circuitos'"
                    :message="'Listar circuitos'"
                    :event="listCircuits"
                    :mobile="$vuetify.breakpoint.xs"
                    :isText="true"
                    :object="pool"
                    :loading="circuitsLoading"
                  ></TooltipButton>

                  <TooltipButton
                    :label="'Associar circuitos'"
                    :message="'Associar circuitos'"
                    :event="openAssociateDialog"
                    :mobile="$vuetify.breakpoint.xs"
                    :isText="true"
                    :object="pool"
                  ></TooltipButton>

                  <TooltipButton
                    :label="'Desassociar circuitos'"
                    :message="'Desassociar circuitos'"
                    :event="openDissociateDialog"
                    :mobile="$vuetify.breakpoint.xs"
                    :isText="true"
                    :object="pool"
                  ></TooltipButton>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>

        <v-row justify="center">
          <v-progress-circular
            v-if="isLoading"
            :size="30"
            :width="4"
            color="blue darken-2"
            indeterminate
            class="ml-n2 mt-3 mb-n1 text-center"
          ></v-progress-circular>
        </v-row>
        <v-row justify="center" v-if="pools.length == 0 && !isLoading">
          <v-lazy :options="{ threshold: 0.6 }" transition="slide-x-transition">
            <WarningPanel
              v-if="!isLoading"
              :message="'Nenhum pool virtual encontrado.'"
            >
            </WarningPanel>
          </v-lazy>
        </v-row>
      </div>
    </v-col>

    <PoolFormDialog
      :dialog="showDialog"
      :pool="selectedPool"
      :close="closeDialog"
      :send="sendPool"
      :isLoading="isLoading"
      :message="message"
    ></PoolFormDialog>

    <VirtualPoolCircuitsDialog
      :dialog="showCircuitsList"
      :pool="selectedPool"
      :close="closeCircuitsList"
      :circuits="circuits"
    >
    </VirtualPoolCircuitsDialog>

    <AssociateCircuitsDialog
      :dialog="associateDialog"
      :entity="selectedPool"
      :close="closeAssociateDialog"
      :send="action == 'associate' ? associateCircuits : dissociateCircuits"
      :action="action"
      :isLoading="associateLoading"
    >
    </AssociateCircuitsDialog>
  </v-layout>
</template>

<script>
import WarningPanel from "../components/panels/WarningPanel";
import TooltipButton from "../components/TooltipButton";
import LabelValue from "../components/LabelValue";
import PoolFormDialog from "../components/dialogs/PoolFormDialog";
import VirtualPoolCircuitsDialog from "../components/dialogs/VirtualPoolCircuitsDialog";
import AssociateCircuitsDialog from "../components/dialogs/AssociateCircuitsDialog";

export default {
  components: {
    WarningPanel,
    TooltipButton,
    LabelValue,
    PoolFormDialog,
    VirtualPoolCircuitsDialog,
    AssociateCircuitsDialog,
  },
  methods: {
    openDissociateDialog(pool) {
      this.action = "dissociate";
      this.associateDialog = true;
      this.selectedPool = pool;
    },
    openAssociateDialog(pool) {
      this.action = "associate";
      this.associateDialog = true;
      this.selectedPool = pool;
    },
    associateCircuits(pool) {
      var object = {};
      object.poolId = pool.id;
      object.circuitsIds = pool.circuitos.map((c) => c.id);
      this.associateLoading = true;

      this.$post("/pool-virtual/associate", object).then(() => {
        this.closeAssociateDialog();
        this.associateLoading = false;
      });
    },
    dissociateCircuits(pool) {
      var object = {};
      object.poolId = pool.id;
      object.circuitsIds = pool.circuitos.map((c) => c.id);
      this.associateLoading = true;

      this.$post("/pool-virtual/dissociate", object).then(() => {
        this.closeAssociateDialog();
        this.associateLoading = false;
      });
    },
    closeAssociateDialog() {
      this.associateDialog = false;
    },
    listCircuits(pool) {
      this.selectedPool = pool;
      this.circuitsLoading = true;
      this.$get("/circuito/pool", { poolId: pool.id }).then((response) => {
        this.circuits = response.data;
        this.showCircuitsList = true;
        this.circuitsLoading = false;
      });
    },
    closeCircuitsList() {
      this.showCircuitsList = false;
    },
    formatSize(sizeGB) {
      if (!sizeGB || sizeGB == 0) return "0";

      const units = ["GB", "TB", "PB"];
      let value = sizeGB;
      let unitIndex = 0;

      while (value >= 1024 && unitIndex < units.length - 1) {
        value /= 1024;
        unitIndex++;
      }

      return value.toFixed(2) + " " + units[unitIndex];
    },
    exportCSV() {
      this.loadingExport = true;
      if (!this.allPools || this.allPools.length == 0) {
        this.$get("/pool-virtual/all", {
          searchText: this.searchText,
        }).then((response) => {
          this.allPools = response.data.map((p) => {
            p.designacao_tpz =
              p.circuitos && p.circuitos.length > 0
                ? p.circuitos[0].designacaoTpz
                : "--";
            p.contrato = p.contrato ? p.contrato.nome : "";
            return p;
          });

          this.$downloadCSV(this.allPools, "Pools Virtuais");
          this.loadingExport = false;
        });
      } else {
        this.$downloadCSV(this.allPools, "Pools Virtuais");
        this.loadingExport = false;
      }
    },
    editPool(pool) {
      this.selectedPool = Object.assign({}, pool);
      this.showDialog = true;
    },
    hasEmptyFields(pool) {
      return !pool.nome || !pool.tamanhoGB || !pool.contrato;
    },
    configAndShowError(data) {
      if (data.code == "500") {
        this.message = data.message;
        this.isLoading = false;
        return true;
      } else {
        this.message = undefined;
        return false;
      }
    },
    sendPool(pool) {
      if (this.hasEmptyFields(pool)) {
        return;
      }

      this.isLoading = true;

      this.$post("/pool-virtual/save", pool).then((response) => {
        if (this.configAndShowError(response.data)) {
          return;
        }

        var element = document.getElementById("main");

        this.$vuetify.goTo(element, {
          duration: 200,
          offset: 25,
          easing: "linear",
        });

        if (!pool.id) {
          setTimeout(() => this.pools.unshift(response.data), 800);
        } else {
          var vm = this;
          this.pools.forEach(function (p, i) {
            if (p.id == response.data.id) {
              vm.pools[i] = response.data;
            }
          });
        }

        this.$root.$emit("invalidateFields");
        this.isLoading = false;
        this.showDialog = false;
        this.message = undefined;
      });
    },
    createPool() {
      this.selectedPool = {};
      this.showDialog = true;
    },
    closeDialog() {
      this.showDialog = false;
      this.isLoading = false;
      this.message = undefined;
    },
    searchMore() {
      this.stickFilters();

      if (this.isLoding || this.noResult) {
        return;
      }

      if (
        document.documentElement.scrollTop + window.innerHeight + 1 >=
        document.documentElement.scrollHeight
      ) {
        this.page++;
        this.search(this.page);
      }
    },
    search(page) {
      this.isLoading = true;
      if (!page) {
        this.page = 0;
        this.pools = [];
        this.noResult = false;
        this.allRequests = undefined;
      }

      this.$get("/pool-virtual/busca", {
        searchText: this.searchText,
        page: this.page,
      }).then((response) => {
        if (response && response.data.length == 0) {
          this.noResult = true;
        }

        this.pools = this.pools.concat(response.data);
        this.isLoading = false;
      });
    },
    stickFilters() {
      if (document.documentElement.scrollTop > 95) {
        document.getElementById("filtro").style =
          "position:sticky; z-index:2; top:66px; box-shadow: 0 0 10px #333; border-radius: 15px;";
      } else if (document.documentElement.scrollTop < 60) {
        document.getElementById("filtro").style = "";
      }
    },
  },
  data: () => ({
    associateLoading: false,
    associateDialog: false,
    action: undefined,
    circuitsLoading: false,
    circuits: [],
    showCircuitsList: false,
    loadingExport: false,
    page: 0,
    isLoading: false,
    noResult: false,
    searchText: "",
    pools: [],
    showDialog: false,
    disabled: false,
    selectedPool: {},
    message: undefined,
    infoDialog: false,
    circuitsDialog: false,
  }),
  created: function () {
    this.isLoading = true;
    this.$get("/pool-virtual/busca", { searchText: undefined, page: 0 }).then(
      (response) => {
        this.pools = this.pools.concat(response.data);
        this.isLoading = false;
      }
    );
  },
};
</script>
